import { render, staticRenderFns } from "./xsjmxList.vue?vue&type=template&id=18b572bc&scoped=true&"
import script from "./xsjmxList.vue?vue&type=script&lang=js&"
export * from "./xsjmxList.vue?vue&type=script&lang=js&"
import style0 from "./xsjmxList.vue?vue&type=style&index=0&id=18b572bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b572bc",
  null
  
)

export default component.exports